<aside id="left_panel" class="nano affix sidebar_left_position" ng-class="tab == 0 ? 'show-mobile-sidebar' : 'hide-mobile-sidebar'">
        <div class="sidebar-head" id="eLeftPanel">
            <div class="sidebar-header p10" style="display:block">
                <strong>Order List</strong>
            </div>
    
            <ul class="sidebar-menu-tab mn pn">
                <li ng-class="statuses.work == 1 ? 'active' : '' " ng-click="setStatus(1,'work')" ng-style="(!data.app_work && !data.show_success_works) && {'width':'100%'}">
                    <a href="#">
                        <h5 class="mbn mtn">{{ getWorkStatus('continue') }}</h5>
                        <small>Pending</small>
                    </a>
                </li>
                <li ng-if="data.app_work || data.show_success_works" ng-class="statuses.work == 0 ? 'active' : '' " ng-click="setStatus(0,'work')">
                    <a href="#">
                        <h5 class="mbn mtn">{{ getWorkStatus('cancel') }}</h5>
                        <small>Fail</small>
                    </a>
                </li>
                <li ng-if="data.app_work || data.show_success_works" ng-class="statuses.work == 2 ? 'active' : '' " ng-click="setStatus(2,'work')">
                    <a href="#">
                        <h5 class="mbn mtn">{{ getWorkStatus('success') }}</h5>
                        <small>Complete</small>
                    </a>
                </li>
            </ul>
        </div>
        <div class="sidebar-block">
            <div class="list-sidebar pn" 
                ng-class="order.id == selectedOrderId ? 'selected-work' : ''"
                ng-repeat="order in data.orders | filter:filterWork" 
                ng-click="clickWork(order)">
             
                <div class="p10 mbn pbn">
                    <p ng-if="data.order_settings.order_description">
                        {{ order.name }}
                    </p>
                    <strong class="order-list-time">
                        <span ng-if="data.order_settings.scheduled_time">
                            {{ order.scheduled_time | amUtc | amDateFormat:'HH:mm' }} - {{ order.scheduled_time | amUtc | amDateFormat:'DD MMM YYYY' }}
                        </span>
    
                        <span ng-style="{'background-color': order.status.color }"
                            ng-if="order.status"
                            class="order-list-status pull-right">{{ order.status.name }}
                        </span>
                        <span 
                            class="pull-right"
                            ng-if="!order.status">
                            Created
                        </span>
    
                        <p ng-if="data.order_settings.order_time">
                            {{ humanizeDuration(order.time) }}
                        </p>
                    </strong> 
    
                    <strong class="order-list-time clearfix mt5 mb5">
                        {{ order.location.name }}
                    </strong>
                    <p class="order-list-address mt5">
                        {{ order.location.address }}
                    </p>
                </div>
                <div class="pl10 pr10 pb5">
                    <p class="order-list-worker" ng-if="order.worker_id != 0" style="font-weight: 600;">
                        <i class="fa fa-user"></i> 
                        {{ order.worker.full_name }}
                        <a href="#" 
                            class="btn btn-default btn-xs pull-right" 
                            style="background: #F3F7FA;color:#5f6c74;font-weight:400"
                            ng-if="data.remaining_time && order.status.value != 'complete' " 
                            ng-click="getRemainingTime(order.id)">Kalan Süre</a>
                    </p>
                    <p class="order-list-worker" ng-if="order.worker_id == 0" class="text-danger">
                        <i class="fa fa-user"></i> Not Assign.
                    </p>
    
                </div>
                <hr class="mn" ng-if="order.dist">
                <div class="p10" ng-if="order.dist">
                    <span ng-if="!order.dist">
                        Kalan süre hesaplanıyor...
                    </span>
                    <span ng-if="order.dist" class="text-warning">
                        Kalan Mesafe : {{ order.dist.distance }},
                        Kalan Süre : {{ order.dist.time }}
                    </span>
                </div>
            </div>
    
            <div class="filter-bottom list-sidebar text-center pl20 pr20" ng-if="paginate.last_page != 1 && paginate.last_page != 0">
                <span style="color: #000 !important;">
                    Page : {{ paginate.current_page }} / {{ paginate.last_page }}, Total Page : {{ paginate.total }}
                </span>
                <ul class="pagination pn mtn">
                    <li ng-disabled="paginate.current_page != 1"><a href="javascript:void(0)" ng-click="getPage(1)">&laquo;</a></li>
                    <li ng-disabled="paginate.current_page != 1"><a href="javascript:void(0)" ng-click="getPage(paginate.current_page-1)">&lsaquo; Prev</a></li>
                    <li ng-disabled="paginate.current_page != paginate.last_page"><a href="javascript:void(0)" ng-click="getPage(paginate.current_page+1)">Next &rsaquo;</a></li>
                    <li ng-disabled="paginate.current_page != paginate.last_page"><a href="javascript:void(0)" ng-click="getPage(paginate.last_page)">&raquo;</a></li>
                </ul>
            </div>
    
            <!--<div class="new-work-today" ng-if="getWorkStatus('assign') == 0 && data.orders == 0">
                <h1>KargoBulunamdı!</h1>
                Hemen iş oluştur.
            </div>-->
    
        </div>
    </aside>
    <div ng-include="'modules/company/dashboard/partials/filter.html'" ng-show="filterPanel" 
        style="left:260px;border-left: 1px solid #ddd;">></div>
    <!--
    <div id="offsidebar-btn"
         ng-click="sidebar('left')" 
         class="sidebar_left_toggle hidden-sm hidden-md"
         ng-style="filterPanel && {'left':'520px'}">
         <i class="fa fa-arrow-left"></i>
    </div>
    -->